import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { FLUSH, PAUSE, PERSIST, persistStore, PURGE, REGISTER, REHYDRATE } from "redux-persist";

import { nextCargoApi } from "./apis/baseApi";
import { ipifyApi } from "./apis/ipify";
import { persistedReducer } from "./rootReducer";
import { listenerMiddleware, middleware } from "./utils";

export const store = configureStore({
  devTools: import.meta.env.MODE !== "production",
  reducer: persistedReducer,
  middleware: (gdm) =>
    gdm({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
      .prepend(middleware, listenerMiddleware)
      .concat(nextCargoApi.middleware, ipifyApi.middleware)
});
export const persistor = persistStore(store);

setupListeners(store.dispatch);
